import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBIcon, MDBView } from "mdbreact";
import { Templates } from "../../../../../services/fakeDb";
import {
  BROWSE,
  RESET,
  SetActivePAGE,
  SetFILTERED,
} from "../../../../../services/redux/slices/diagnostics/laboratory/preferences";

const DEPARTMENTS = [
  { key: "LAB", label: "Laboratory" },
  { key: "RAD", label: "Radiology" },
];

const Header = () => {
  const { activePlatform, token } = useSelector(({ auth }) => auth),
    { collections, cluster } = useSelector(({ preferences }) => preferences),
    [department, setDepartment] = useState("LAB"),
    [template, setTemplate] = useState(""),
    [search, setSearch] = useState(""),
    dispatch = useDispatch();

  // Initial Browse
  useEffect(() => {
    if (token && activePlatform?.branchId) {
      dispatch(BROWSE({ token, branchId: activePlatform?.branchId }));
    }

    return () => dispatch(RESET());
  }, [token, activePlatform, dispatch]);

  // sections (templates) of the department
  const components = useMemo(
    () =>
      Templates?.collections?.find(({ department: d }) => d === department)
        ?.components || [],
    [department],
  );

  // department -> section -> name / abbreviation
  const results = useMemo(() => {
    const key = search.trim().toLowerCase();
    return collections.filter(
      ({ department: d, template: t, name = "", abbreviation = "" }) =>
        (!department || d === department) &&
        (template === "" || t === Number(template)) &&
        (!key ||
          name.toLowerCase().includes(key) ||
          abbreviation.toLowerCase().includes(key)),
    );
  }, [collections, department, template, search]);

  // also follows reference value changes, without leaving the current page
  useEffect(() => {
    dispatch(SetFILTERED(results));
  }, [results, dispatch]);

  // a new filter starts on the first page
  useEffect(() => {
    dispatch(SetActivePAGE(1));
  }, [department, template, search, dispatch]);

  return (
    <MDBView
      cascade
      className="gradient-card-header custom-header blue-gradient narrower py-2 mx-4 d-flex flex-wrap justify-content-between align-items-center"
      style={{ gap: 8 }}
    >
      <div className="d-flex align-items-center">
        <span className="white-text font-weight-bold mr-2">Services:</span>
        <span className="font-weight-bold">{cluster.length}</span>
      </div>
      <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
        <select
          className="form-control bg-light"
          style={{ width: "11rem" }}
          value={department}
          onChange={({ target }) => {
            setDepartment(target.value);
            setTemplate("");
          }}
        >
          <option value="">All departments</option>
          {DEPARTMENTS.map(({ key, label }) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
        <select
          className="form-control bg-light"
          style={{ width: "13rem" }}
          value={template}
          disabled={!department}
          onChange={({ target }) => setTemplate(target.value)}
        >
          <option value="">All sections</option>
          {components.map((name, index) => (
            <option key={name} value={index}>
              {name}
            </option>
          ))}
        </select>
        <div className="position-relative" style={{ width: "16rem" }}>
          <MDBIcon
            icon="search"
            className="position-absolute text-muted"
            style={{ top: "50%", left: 12, transform: "translateY(-50%)" }}
          />
          <input
            type="search"
            className="form-control bg-light"
            style={{ paddingLeft: 34 }}
            placeholder="Search service or abbreviation"
            value={search}
            onChange={({ target }) => setSearch(target.value)}
          />
        </div>
      </div>
    </MDBView>
  );
};

export default Header;
